import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import MenuItem from './MenuItem'
import CSSModules from 'react-css-modules'
import styles from './menu.css'
import { Link, browserHistory } from 'react-router'
import cookie from 'react-cookie'
import { api, domen } from '../../config.js'

/**
 *  Компонент Menu.
 *  Используется для вывода меню
 *
 */
class Menu extends Component {
  /**
   * @memberof  Menu
   * @prop {object} propTypes - the props that are passed to this component
   * @prop {array} propTypes.menuList Список разделов
   * @prop {number} propTypes.program Номер программы
   * @prop {string} propTypes.gender Пол
   * @prop {object} propTypes.sign Объект данных реги
   *
   * */

  static propTypes = {
    gender: PropTypes.string,
    program: PropTypes.number,
    sign: PropTypes.object.isRequired,
    menuList: PropTypes.array.isRequired
  }
  render() {

    let { gender, dayId, sign, program, prevSeasons, unReadMsgs, userInfo } = this.props;
    let { menuList } = this.props;
    const { banners } = userInfo.data;
    const { host } = sign;
    const pr = program ? program : (prevSeasons ? prevSeasons[0].id : 0);
    //const isAlfa = domen.isAlfa
   let imgs = [
      'extreme_suches11.png',
      'ya_heroi11.png',
      'mama_mozhet11.png'
    ];
    if(pr % 4 === 1){
      imgs = imgs.slice(0,2)
    }
    if(true){
      imgs = imgs.slice(1)
    }
    if(pr % 4 === 3){
      imgs = imgs.slice(0,1)
    }
    const error = {
      name: 'Вопросы и предложения',
      active: false,
      link: 'error-report',
      icon: 'ico-warning'
    }
    if(host === 'alfa'){
      menuList = menuList.filter(item => {
        return item.link !== 'seasons'
      })
    }

    return (
      <div className={styles.gridCellLayoutMenuNav23}>
        <ul className="main-nav">
          {menuList.map((item, index) => {
            return (
              <MenuItem
                key={index}
                item={item}
                unReadMsgs={unReadMsgs}
                dayId={dayId}
              />
            )
          })}
          <li className="main-nav__item--line" />
          <MenuItem
            item= {error}
            dayId={dayId}
          />
        </ul>

          {
              banners && !!banners.length && banners.map(item => {
                  if(item.link){
                      return (
                          <a className={styles.bannerLsLink} href={item.link} target='_blank'>
                              <div className={styles.bannerLsItem}>
                                  <img role="presentation" className={styles.seasonImage}
                                       src={item.image}
                                  />
                              </div>
                          </a>
                      )
                  } else {
                      return (
                          <div className={styles.bannerLs}>
                              <div className={styles.bannerLsItem}>
                                  <img role="presentation" className={styles.seasonImage}
                                       src={item.image}
                                  />
                              </div>
                          </div>
                      )
                  }
            })
          }

        {pr && (cookie.load('userPaidState') == 0 || cookie.load('userPaidState') == -1)
          ? <ul className={styles.bannerLs}>
            <li className={styles.bannerLsItem}>
              <img role="presentation" className={styles.seasonImage}
                   src={`/assets/img/png/${imgs[Math.floor(Math.random() * imgs.length)]}`}
                   onClick={() => {
                        browserHistory.push('/season')
                    }}/>


            </li>
          </ul>
          : null
        }
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { menuList, sign, userInfo } = state
  return {
    menuList,
    userInfo,
    sign
  }
}

Menu = connect(
  mapStateToProps
)(Menu)

export default CSSModules(Menu, styles)



// WEBPACK FOOTER //
// /var/www/build-health-2/src/components/todayTask/Menu.js